export default "__VITE_ASSET__D7ki9sq1__"